import { connect } from "react-redux";
import * as financingActions from "../../../services/financing/actions";

//Used to format the dates correctly without timezone (ToDo add this globally somehow?)

function mapStateToProps(state) {
  return {
    financingsIssued: state.financing.financingsIssued,
    accountInfo: state.financing.accountInfo,
    loansForPayout: state.financing.loansForPayout,
    payout: state.payout,
    isMpl: false,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getFinancingBookingAccountInfo: (accountId) => {
      dispatch(financingActions.get_financing_booking_account_info(accountId));
    },

    changeFinancingIssuedListPage: (page) => {
      dispatch(financingActions.change_financing_list_page(page, "Issued"));
    },

    changeFinancingIssuedListFilter: (keyName, event) => {
      dispatch(
        financingActions.change_financing_list_filter(
          keyName,
          event.target.value,
          "Issued",
        ),
      );
    },

    getFinancingPayoutInfo: (financingId) => {
      dispatch(financingActions.get_financing_payout_info(financingId));
    },

    registerPayouts: (financingIds) => {
      dispatch(financingActions.register_financing_payouts(financingIds));
    },

    registerPayout: (financingId) => {
      dispatch(financingActions.register_financing_payout(financingId));
    },

    cancelLoan: (loanId) => {
      dispatch(financingActions.cancel_loan(loanId));
    },

    getLoansForPayout: () => {
      dispatch(financingActions.get_loans_for_payout());
    },

    pushErrorNotification: (message) => {
      dispatch({
        type: "ERROR_NOTIFIACTION",
        message,
      });
    },
  };
}

export const payoutConnector = connect(mapStateToProps, mapDispatchToProps);
